module.exports = __webpack_public_path__ + "img/image3.24ef8333.jpg";